import React from 'react';
export const CheckMarkSvg: React.FC = () => {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3656 0.234229C11.5156 0.384251 11.5998 0.587698 11.5998 0.799829C11.5998 1.01196 11.5156 1.21541 11.3656 1.36543L4.96559 7.76543C4.81557 7.91541 4.61212 7.99966 4.39999 7.99966C4.18786 7.99966 3.98441 7.91541 3.83439 7.76543L0.63439 4.56543C0.488664 4.41455 0.408028 4.21247 0.409851 4.00271C0.411674 3.79295 0.495809 3.5923 0.644135 3.44397C0.792462 3.29565 0.993112 3.21151 1.20287 3.20969C1.41263 3.20787 1.61471 3.2885 1.76559 3.43423L4.39999 6.06863L10.2344 0.234229C10.3844 0.0842524 10.5879 0 10.8 0C11.0121 0 11.2156 0.0842524 11.3656 0.234229Z"
        fill="#D3E9CE"
      />
    </svg>
  );
};
